import Base64 from "crypto-js/enc-base64";
import HmacSHA256 from 'crypto-js/hmac-sha256';
import { getEnv } from 'webmd-url';

if (typeof(window) !== 'undefined') {
	if (document.location.hostname !== 'localhost') {
		var urlEnv = getEnv();
	} else {
		var urlEnv = 'localhost';
	}
}

const webmdOauth = {

	webmdEnv: '',
	/**
	 * Generates an oauth object to send with requests for solr search APIs
	 * @param {object} options
	 * @returns {object}
	 */
	generate(options, env) {
		const self = this;
		self.webmdEnv = env || self.getEnv();
		const settings = Object.assign({}, self.getDefaults(), options);

		if (!Base64 || !HmacSHA256) {
			console.error('webmd.oauth error: CryptoJS module not loaded');
		} else {
			return {
				enc_data: Base64.stringify(HmacSHA256(`{{timestamp:${new Date().toGMTString()},client_id:${settings.client_id}}}`, settings.secret_key)),
				timestamp: new Date().toGMTString(),
				client_id: settings.client_id,
			};
		}
		return {};
	},

	/**
	 * Get the default environment
	 * @returns {object}
	 */
	getEnv() {
		return urlEnv;
	},
	/**
	 * Get the default per environment
	 * @returns {object}
	 */
	getDefaults() {
		const self = this;
		switch (self.webmdEnv) {
			case '.dev01':
			case '.dev02':
			case '.dev03':
			case '.dev04':
			case '.devint':
			case '.feature':
				return {
					client_id: "28c8b711-b6b8-440c-9e78-d56a1bcc4aa2",
					secret_key: "9d75e92b-11e9-45e0-88e2-6602869dfb82",
				};

			case '.perf':
			case '.qa02':
				return {
					client_id: '6d583099-1dee-4ead-962f-b736b162cfe5',
					secret_key: 'd25e940c-482d-46e9-b2d4-6f987f528d26',
				};

			case '.qa01':
			case  '.qa':
				return {
					client_id: '6d583099-1dee-4ead-962f-b736b162cfe5',
					secret_key: 'd25e940c-482d-46e9-b2d4-6f987f528d26',
				};

			case '.qa00':
				return {
					client_id: '91cf0723-200a-43b2-8107-078e3d8f3406',
					secret_key: 'bb1f7fc7-9db8-4542-b289-c0b57775cd61',
				};

			// Production
			default:
				return {
					client_id: 'e4e3f73a-0ceb-4d37-939e-90ddb1238360',
					secret_key: '8720f366-3769-47e9-8156-187b9c6583b5',
				};
		}
	},
};

export default webmdOauth;
